import React, { ReactElement } from 'react';
import { FastField as FormikField } from 'formik';
import { Textarea } from '@xo-union/tk-component-fields';

interface TextAreaProps {
  name: string;
  placeholder: string;
  disabled: boolean;
}

const TextArea: React.FC<TextAreaProps> = ({ name, placeholder, disabled = false }) => (
  <FormikField name={name}>
    {({ field }: { field: any }): ReactElement => (
      <Textarea name="" label="" placeholder={placeholder} rows={3} {...field} disabled={disabled} />
    )}
  </FormikField>
);

TextArea.propTypes = {};

export default TextArea;
